export const home_menu = [
  {
    name: "이용가이드",
    icon: "icn_webordermenu1.svg",
    link: "https://minthouse.co.kr/guide_pickup_inapp",
  },
  {
    name: "주문내역",
    icon: "icn_webordermenu2.svg",
    link: "order/history",
  },
  {
    name: "장바구니",
    icon: "icn_webordermenu3.svg",
    link: "products/list",
  },
  {
    name: "FAQ",
    icon: "icn_webordermenu4.svg",
    link: "https://minthouse.co.kr/faq_inapp/?jsf=epro-posts&tax=portfolio_category:39",
  },
];

export const home_menus = {
  cosmocare: [
    {
      name: "서비스안내",
      icon: "icn_home_btn_cosmocare1.svg",
      link: "https://mintapps.oopy.io/cosmocare-service",
    },
    {
      name: "주문내역",
      icon: "icn_home_btn_cosmocare2.svg",
      link: "order/history",
    },
    {
      name: "장바구니",
      icon: "icn_home_btn_cosmocare3.svg",
      link: "products/list",
    },
    {
      name: "FAQ",
      icon: "icn_home_btn_cosmocare4.svg",
      link: "https://mintapps.oopy.io/faq/cosmocare-faq",
    },
  ],
  smcare: [
    {
      name: "서비스안내",
      icon: "icn_home_btn_smcare1.svg",
      link: "https://mintapps.oopy.io/smcare-service",
    },
    {
      name: "주문내역",
      icon: "icn_home_btn_smcare2.svg",
      link: "order/history",
    },
    {
      name: "장바구니",
      icon: "icn_home_btn_smcare3.svg",
      link: "products/list",
    },
    {
      name: "FAQ",
      icon: "icn_home_btn_smcare4.svg",
      link: "https://mintapps.oopy.io/faq/smcare-faq",
    },
  ],

  other: [
    {
      name: "이용가이드",
      icon: "icn_webordermenu1.svg",
      link: "https://minthouse.co.kr/guide_pickup_inapp",
    },
    {
      name: "주문내역",
      icon: "icn_webordermenu2.svg",
      link: "order/history",
    },
    {
      name: "장바구니",
      icon: "icn_webordermenu3.svg",
      link: "products/list",
    },
    {
      name: "FAQ",
      icon: "icn_webordermenu4.svg",
      link: "https://minthouse.co.kr/faq_inapp/?jsf=epro-posts&tax=portfolio_category:39",
    },
  ],
};

export const category_menu = [
  { category_id: 0, category_name: "의류" },
  { category_id: 1, category_name: "신발" },
  { category_id: 2, category_name: "가방" },
];
export const material_menu = [
  { category_id: 0, material_id: 0, material_name: "셔츠" },
  { category_id: 0, material_id: 1, material_name: "패딩" },
  { category_id: 0, material_id: 2, material_name: "바지" },
  { category_id: 1, material_id: 0, material_name: "스니커즈" },
  { category_id: 1, material_id: 1, material_name: "구두 (남성,여성)" },
  { category_id: 1, material_id: 2, material_name: "아웃도어 슈즈" },
  { category_id: 2, material_id: 0, material_name: "가죽" },
  { category_id: 2, material_id: 1, material_name: "세무" },
];
